export default "__VITE_ASSET__vfoowk8Y__"